export default __webpack_public_path__ + "2768b24ad79fa14bc86ad00b75d848e8.png";